import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { FormGroup, InputGroup } from 'react-bootstrap';
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { searchPatients } from '../../api/database';
import { Search } from '../Icons/Icons';
import { HandleApiError } from "../Notifications/APIErrorHandler";
import '../../assets/sass/lbd/_asyncTypeahead.scss';
import { useTranslation } from 'react-i18next';

export const PatientPicker = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const { t } = useTranslation();

    const handleChange = value => {
        if (value.length > 0)
            props.onChange(props.name, value[0]);
        else
            props.onChange(props.name, null);
    };

    const handleBlur = () => {
        if (props.onBlur)
            props.onBlur(props.name, true);
    };

    const onSearch = (query) => {
        setIsLoading(true);

        searchPatients(query).then(response => {
            setOptions(response.data);
            setIsLoading(false);

        }).catch(error => {
            setIsLoading(false);
            setOptions([]);
            HandleApiError(error);
        });
    }

    const renderMenuItemChildren = (option, { text }, index) => {
        return (
            <Fragment key={index}>
                <Highlighter search={text}>
                    {option.fullName}
                </Highlighter>
                <div>
                    <small>
                        <b>{t("medicalRecords.patientInfo.medicalRecord")}:</b> <Highlighter search={text}>{option.medicalRecordNumber}</Highlighter>, <b>{option.identificationType}</b>: <Highlighter search={text}>{option.identificationNumber}</Highlighter>
                    </small>
                </div>
            </Fragment>
        )
    };

    const typeahead = (<AsyncTypeahead
        {...props}
        renderMenuItemChildren={renderMenuItemChildren}
        labelKey="fullNameUnique"
        filterBy={() => true}
        options={options}
        isLoading={isLoading}
        clearButton={true}
        highlightOnlyResult={true}
        allowNew={false}
        delay={1000}

        onSearch={onSearch}
        onChange={handleChange}
        onBlur={handleBlur}
    />);

    if (props.showSearchIcon)
        return (
            <FormGroup>
                <InputGroup>
                    <InputGroup.Addon><Search /></InputGroup.Addon>
                    {typeahead}
                </InputGroup>
            </FormGroup>
        );

    return typeahead;
}

PatientPicker.propTypes = {
    multiple: PropTypes.bool,
    onChange: PropTypes.func,
    minLength: PropTypes.number,
    showSearchIcon: PropTypes.bool,
};

PatientPicker.defaultProps = {
    multiple: false,
    onChange: () => { },
    minLength: 2,
    showSearchIcon: false,
};